
  (function () {
    // Config
    var BAR_ID = 'free-shipping-bar';
    var MSG_ID = 'free-shipping-message';
    var CLOSE_ID = 'free-shipping-close';
    var LOCALSTORAGE_KEY = 'freeShippingBarClosed';

    // Helpers: format money
    function formatMoney(cents) {
      try {
        const amount = cents / 100;
        const locale = 'en-US';

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: 'USD',
        }).format(amount);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    // DOM helpers
    function $(id) {
      return document.getElementById(id);
    }
    function showBar() {
      var el = $(BAR_ID);
      if (el) el.style.display = 'block';
    }
    function hideBar() {
      var el = $(BAR_ID);
      if (el) el.style.display = 'none';
    }
    // Only touch the DOM when the text actually changes. The server already
    // renders the default message, so rewriting it with an identical string is
    // what made the bar flicker after load.
    function normalize(html) {
      return String(html).replace(/\s+/g, ' ').trim();
    }
    function setMessage(html) {
      var msgEl = $(MSG_ID);
      if (!msgEl) return;
      if (normalize(msgEl.innerHTML) === normalize(html)) return;
      msgEl.innerHTML = html;
    }
    function updateMessage(cartTotalCents, thresholdCents) {
      if (cartTotalCents >= thresholdCents) {
        setMessage(successMessage);
        return;
      }

      var remaining = thresholdCents - cartTotalCents;
      if (cartTotalCents > 0 && remaining > 0) {
        setMessage('Only <strong>' + formatMoney(remaining) + '</strong> ' + remainingMessage);
      } else {
        // thresholdDisplay is the same Liquid `money` output the server printed,
        // so this branch is byte-identical to the rendered markup.
        setMessage(defaultMessage + ' <strong>' + thresholdDisplay + '</strong>');
      }
    }
    function fetchCartAndUpdate(thresholdCents) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var cartTotal = cart && cart.total_price ? cart.total_price : 0;
          updateMessage(cartTotal, thresholdCents);
          showBar();
        })
        .catch(function () {
          setMessage(defaultMessage + ' <strong>' + thresholdDisplay + '</strong>');
          showBar();
        });
    }

    // Sticky on scroll

    const bar = document.getElementById('free-shipping-bar');

    // A 1px sentinel marks where the bar naturally sits. While it is in view the
    // bar stays in flow; once it scrolls out of view the bar pins. An observer
    // fires once per crossing, where the old `scrollY > bar.offsetTop` test
    // re-fired on every scroll event near the threshold — which re-added the
    // class, which replayed the slide-in animation. That was the shake.
    // The negative margin keeps the sentinel out of the layout.
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;';

    // Reserves the bar's height only while pinned, so the page does not jump by
    // the bar's height at the moment it leaves the flow. Measured at pin time,
    // not once at load: the bar's height changes with the message text.
    const placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';

    bar.parentNode.insertBefore(sentinel, bar);
    bar.parentNode.insertBefore(placeholder, bar);

    function setPinned(pinned) {
      if (bar.classList.contains('is-sticky') === pinned) return;
      if (pinned) placeholder.style.height = bar.offsetHeight + 'px';
      bar.classList.toggle('is-sticky', pinned);
      placeholder.style.display = pinned ? 'block' : 'none';
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          setPinned(!entries[0].isIntersecting);
        },
        { threshold: 0 }
      ).observe(sentinel);
    }

    const defaultMessage = bar.dataset.defaultMessage;
    const remainingMessage = bar.dataset.remainingMessage;
    const successMessage = bar.dataset.successMessage;
    // Same schema value, same Liquid `money` filter as the server-rendered text.
    const thresholdDisplay = bar.dataset.thresholdDisplay;

    // Initialize
    document.addEventListener('DOMContentLoaded', function () {
      var bar = $(BAR_ID);
      if (!bar) return;

      // Read threshold from data attribute (cents)
      var thresholdCents = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 100 * 100;

      // The server renders the default message, so this only covers a blank slot.
      if (thresholdDisplay && $(MSG_ID) && !$(MSG_ID).innerHTML.trim()) {
        setMessage(defaultMessage + ' <strong>' + thresholdDisplay + '</strong>');
      }

      // Close button
      var closeBtn = $(CLOSE_ID);
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          hideBar();
        });
      }

      // Initial fetch
      fetchCartAndUpdate(thresholdCents);

      // Listen for common AJAX cart events (themes differ)
      document.addEventListener('cart:updated', function () {
        fetchCartAndUpdate(thresholdCents);
      });
      document.addEventListener('cart:refresh', function () {
        fetchCartAndUpdate(thresholdCents);
      });

      // If your theme triggers custom events on add-to-cart, you can add them here:
      // document.addEventListener('ajaxCart.afterAdd', function () { fetchCartAndUpdate(thresholdCents); });

      // Poll as a fallback for themes that don't emit events (every 3s)
      var lastTotal = null;
      setInterval(function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var t = cart.total_price || 0;
            if (t !== lastTotal) {
              lastTotal = t;
              updateMessage(t, thresholdCents);
              if (t < thresholdCents) showBar();
            }
          })
          .catch(function () {
            /* ignore */
          });
      }, 3000);
    });
  })();
